// extracted by mini-css-extract-plugin
module.exports = {"selectTemplateContainer":"_2B-eLg5WxmrAwDGYY1urHo","editTemplateLinkContainer":"_1oQGw1xri8siLyMhFomt6Y"};